module.exports = __webpack_public_path__ + "static/img/SelectTopic01.6414e7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/SelectTopic01.png
// module id = 9kj3
// module chunks = 24